<template>
    <div>
        <div class="app-content">
            <div class="goodsImg">
                <!-- <img src="../../assets/images/slices.png" alt=""> -->
                <ul ref="imgBox" @transitionend="animateEnd" @touchstart="touchstart" @touchmove="touchmove" @touchend="touchend" :style="{ 'width': imgArr.length+2 + '00%','transform': 'translateX(-'+ 100/(imgArr.length+2)+'%)'}">
                    <li><img :src="imgArr[imgArr.length-1].src" alt=""></li>
                    <li v-for="(item, index) in imgArr" :key="index"><img :src="item.src" alt=""></li>
                    <li><img :src="imgArr[0].src" alt=""></li>
                </ul>
                <!-- <div @click="clickGoBank" class="goBack"></div> -->
                <div class="imgArrIndex"><span>{{ imgArrIndex+1 }}/{{ imgArr.length }}</span></div>
            </div>
            <div class="price">
                <div class="priceBox">
                  <div class="priceImg">
                    <img :src="this.imgUrl + goodsForm.iconUrl" alt="">
                  </div>
                  <div class="priceCantent">
                    <span class="preferentialPrice">￥{{ goodsForm.preferentialPrice }} <div><span>限时折扣</span></div></span>
                    <span class="marketPrice"><s>￥{{ goodsForm.marketPrice }}</s></span>
                  </div>
                </div>
            </div>
            <div class="introduce">
                <h1>{{ goodsForm.name }}</h1>
                <p>{{ goodsForm.introduce }}</p>
            </div>
            <!-- <div class="separate"></div>
            <div class="describe">
                <b>描述：</b> {{ goodsForm.introduce }}
            </div> -->
        </div>
        <div class="footer">
            <button @click="Unlock">立即解锁</button>
        </div>
        <div class="specifications" :class="whethershow ? 'zhankai' : 'otherzhankai'">
            <span class="close" @click="close"></span>
            <div class="productDetails">
              <div class="icon">
                <img v-show="tagActive == 1" src="../../assets/images/wholeIcon.png" alt="">
                <img v-show="tagActive == 0" :src="goodsInfoForm.iconUrl" alt="">
              </div>
              <div class="priceIntroduction">
                <div class="title">{{ goodsInfoForm.name }}</div>
                <div class="priceCantent">
                    <span class="preferentialPrice">￥{{ goodsInfoForm.preferentialPrice }} <div><span>限时折扣</span></div></span>
                    <span class="marketPrice"><s>￥{{ goodsInfoForm.marketPrice }}</s></span>
                  </div>
              </div>
            </div>
            <div class="select">
              <span class="text">产品规格</span>
              <span class="selectSpecifications">
                <div class="item" :class="{ 'active': tagActive == 0 }" @click="commodity">{{ goodsForm.name }}</div>
                <div v-if="goodsForm.batchInfo" class="item" :class="{ 'active': tagActive == 1 }" @click="commodityAll">全部技能</div>
              </span>
            </div>
            <div class="purchaseBox">
              <button @click="payment">立即购买</button>
            </div>
        </div>
        <!--背景半透明处理-->
        <div class="maskBack" @click="close" :style="!whethershow ? 'display:none' : 'display:block;zIndex:19'"></div>
    </div>
</template>
<script>
import store from '@/store'
import { getUserProduct } from '@/api/goods/goods'
import { getAlipay } from '@/api/Alipay/Alipay'
import { setToken } from '@/utils/auth'
export default{
    name:"goods",
    data(){
        return{
            goodsInfoForm:{},
            whethershow: false,
            tagActive: 0,
            goodsId: '', //商品Id
            goodsForm: {},
            imgArr: [], 
            imgArrIndex: 0,
            flag: true, 
            imgIndex: 0,
            imgWidth: 0,
            startX: 0,
            moveX: 0,
            timerd: ''
        }
    },

    watch: {
        flag(val){
            if (val == false) {
                clearTimeout(this.timerd);
                this.timerd = setTimeout(() => {
                  this.flag = true;
                  clearTimeout(this.timerd);
                }, 1000);
            }
        }
    },

    computed: {
      translateX(){
        return -(this.imgWidth + this.imgWidth * this.imgIndex);
      }
    },

    // 页面加载钩子
    async created() {
      store.dispatch('settings/setTitle', '银成圣云执业医师考试')
      if (this.$route.query.id) {
        this.goodsId = this.$route.query.id
      }
      if (this.$route.query.token) {
        setToken(this.$route.query.token)
        this.$store.commit('SET_TOKEN', this.$route.query.token);
      }
      await this.getDoodsInfo();
      // document.body.style.background = 'linear-gradient(180deg, #FFFFFF 60%, #AEF4FB 100%)'
    },

    mounted() {
      this.imgWidth = window.innerWidth;
      this.$refs.imgBox.style.transform = `translateX(-${this.imgWidth}px)`;
    },

    methods:{
        // 根据id获取商品详情
        getDoodsInfo(){
            getUserProduct({skillId: this.goodsId}).then(response => {
              if (response.data.introduceUrls) {
                this.imgArr = []
                let arr = response.data.introduceUrls.split(',');
                arr.forEach(item => {
                    this.imgArr.push({src: `${this.imgUrl}${item}`})
                });
              }
              if (response.data.marketPrice) {
                if (!((response.data.marketPrice + '').indexOf('.') !== -1)) {
                  response.data.marketPrice = response.data.marketPrice.toFixed(2)
                }
                if (response.data.marketPrice.toString().split('.').pop().length < 2) {
                  response.data.marketPrice = response.data.marketPrice + '0'
                }
              }
              if (response.data.preferentialPrice) {
                if (!((response.data.preferentialPrice + '').indexOf('.') !== -1)) {
                  response.data.preferentialPrice = response.data.preferentialPrice.toFixed(2)
                }
                if (response.data.preferentialPrice.toString().split('.').pop().length < 2) {
                  response.data.preferentialPrice = response.data.preferentialPrice + '0'
                }
              }
              if (response.data.batchInfo) {
                if (response.data.batchInfo.marketPrice) {
                  if (!((response.data.batchInfo.marketPrice + '').indexOf('.') !== -1)) {
                    response.data.batchInfo.marketPrice = response.data.batchInfo.marketPrice.toFixed(2)
                  }
                  if (response.data.batchInfo.marketPrice.toString().split('.').pop().length < 2) {
                    response.data.batchInfo.marketPrice = response.data.batchInfo.marketPrice + '0'
                  }
                }
                if (response.data.batchInfo.preferentialPrice) {
                  if (!((response.data.batchInfo.preferentialPrice + '').indexOf('.') !== -1)) {
                    response.data.batchInfo.preferentialPrice = response.data.batchInfo.preferentialPrice.toFixed(2)
                  }
                  if (response.data.batchInfo.preferentialPrice.toString().split('.').pop().length < 2) {
                    response.data.batchInfo.preferentialPrice = response.data.batchInfo.preferentialPrice + '0'
                  }
                }
              }
              this.goodsForm = response.data
            }).catch(error => {
            //   this.$message.error('接口异常！');
            });
        },

        // 返回app
        clickGoBank(){
            console.log('返回app');
        },

        commodityAll(){
          if (this.goodsForm.batchInfo) {
            this.goodsInfoForm = {
              // iconUrl: require('../../assets/images/wholeIcon.png'),
              iconUrl: '',
              name: '全部实践技能',
              preferentialPrice: this.goodsForm.batchInfo.preferentialPrice,
              marketPrice: this.goodsForm.batchInfo.marketPrice,
            }
            this.tagActive = 1
          } else {
            this.$message.error('数据异常！暂不可选择全部技能');
          }
        },

        commodity(){
          this.goodsInfoForm = {
            iconUrl: `${this.imgUrl}${this.goodsForm.iconUrl}`,
            name: this.goodsForm.name,
            preferentialPrice: this.goodsForm.preferentialPrice,
            marketPrice: this.goodsForm.marketPrice,
          }
          this.tagActive = 0
        },

        Unlock(){
          this.goodsInfoForm = {
            iconUrl: `${this.imgUrl}${this.goodsForm.iconUrl}`,
            name: this.goodsForm.name,
            preferentialPrice: this.goodsForm.preferentialPrice,
            marketPrice: this.goodsForm.marketPrice,
          }
          this.tagActive = 0
          this.whethershow = true
        },

        close(){
          this.whethershow = false
        },

        // 付款按钮
        payment(){
          let params = {
            productInfoId: this.goodsForm.id,
            all: this.tagActive
          }
            getAlipay(params).then(res => {
              const div = document.createElement('div')
              div.id = 'formdata'
		          div.innerHTML = res.data
		          document.body.appendChild(div)
              const form=document.getElementById('formdata');
		          document.forms[0].submit()
              document.body.removeChild(form)
            }).catch(() => {
              
            });
        },

        animateEnd(){
          if(this.imgIndex >= this.imgArr.length){
            this.imgIndex = 0;
            this.imgArrIndex = this.imgIndex
            this.$refs.imgBox.style.transition = 'none';
            this.$refs.imgBox.style.transform = `translateX(-${this.imgWidth}px)`;
          }
          if(this.imgIndex < 0){
            this.imgIndex = this.imgArr.length-1;
            this.imgArrIndex = this.imgIndex
            this.$refs.imgBox.style.transition = 'none';
            this.$refs.imgBox.style.transform = `translateX(${this.translateX}px)`;
          }
          this.flag = true;
        },


        touchstart(event){ 
          if(this.flag){  
            this.startX = event.targetTouches[0].clientX;
          }
        },
        
        touchmove(event){
          if(this.flag){
            this.moveX = event.targetTouches[0].clientX - this.startX;
            this.$refs.imgBox.style.transition = 'none';
            this.$refs.imgBox.style.transform = `translateX(${this.translateX + this.moveX}px)`;
          }
        },
        touchend(event){
          if(this.flag){
            if(this.moveX > 80){
              this.imgIndex--;
              this.imgArrIndex = this.imgIndex
            } else if(this.moveX < -80){
              this.imgIndex++;
              this.imgArrIndex = this.imgIndex
            }
            this.$refs.imgBox.style.transition = 'all .5s';
            this.$refs.imgBox.style.transform = `translateX(${this.translateX}px)`;
            if(this.imgIndex >= this.imgArr.length){
              this.imgArrIndex = 0;
            }
            if(this.imgIndex < 0){
              this.imgArrIndex = this.imgArr.length-1;
            }
            this.flag = false;
          }
        //   this.flag = false;
        }
    }
}
</script>
<style lang="scss">
.app-content {
    // width: 10rem;
    margin-bottom: 2.4533rem;
    height: 102%;
    width: 100%;
    .goodsImg {
        position: relative;
        // overflow: hidden;
        img {
            width: 100%;
            height: 10.6667rem;
            display: block;
        }
        ul {
            overflow: hidden;
            // width: 700%;
            // margin-left: -100%;
            padding: 0;
            li {
                width: 10rem;
                height: 10.6667rem;
                list-style: none;
                float: left;
            }
        }
        .goBack {
            width: .64rem;
            height: .64rem;
            position: absolute; 
            background-color: #fff;
            top: 0.2667rem;
            left: 0.4267rem;
            border-radius: 50%;
            background: url('../../assets/icons/goBack.png');
            background-size: 100%;
        }
        .imgArrIndex {
            width: 1.0667rem;
            height: .6933rem;
            background-color: #302c2c8f;
            position: absolute;
            right: .2667rem;
            bottom: .2667rem;
            border-radius: .4rem;
            font-size: .2667rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #dddbdbfa;
        }
    }
    .price {
        // width: 10rem;
        width: 100%;
        height: 2.24rem;
        background: linear-gradient(90deg, #F6C651 0%, #FFA200 100%);
        opacity: 1;
        padding: .4267rem 0 .48rem .6133rem;
        .priceBox {
          width: 9.3867rem;
          height: 1.3333rem;
          display: flex;
          .priceImg {
            width: 1.3333rem;
            height: 1.3333rem;
            border-radius: .2133rem;
            background: url('../../assets/images/imgBack.png');
            background-size: 100%;
            img {
              width: 1.3333rem;
              height: 1.3333rem;
              border-radius: .2133rem;
            }
          }
          .priceCantent {
            height: .88rem;
            width: 5.3333rem;
            margin-top: .5067rem;
            margin-left: .2133rem;
            .preferentialPrice {
              line-height: .88rem;
              font-size: .64rem;
              font-weight: 600;
              color: #000000;
              float: left;
              position: relative;
              div {
                width: 1.6rem;
                height: .7467rem;
                position: absolute;
                top: -0.48rem;
                right: -1.28rem;
                background: url('../../assets/images/preferential.png') no-repeat;
                background-size: 100%;
                padding-left: .1067rem;
                span {
                  width: 1.4933rem;
                  height: .5333rem;
                  font-size: .3467rem;
                  font-weight: 400;
                  color: #FFFFFF;
                  float: left;
                  line-height: .5867rem;
                }
              }
            }
            .marketPrice {
              height: .88rem;
              font-size: .3733rem;
              line-height: .9333rem;
              font-weight: 400;
              color: #5E5E5E;
              margin-left: .1867rem;
              float: left;
            }
          }
        }
    }
    .introduce {
        padding: .4rem .4rem .5333rem .4rem;
        min-height: 5.0667rem;
        width: 100%;
        background: linear-gradient(180deg, #FFFFFF 0%, #AEF4FB 100%);
        h1 {
            font-size: .5867rem;
            font-weight: 600;
            line-height: .6933rem;
            color: #000000;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        p {
            margin-top: .3733rem;
            font-size: .3733rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            word-break: break-all;
        }
    }
    .separate {
        // width: 10rem;
        width: 100%;
        height: .16rem;
        background: #F8F8F8;
    }
    .describe {
        padding: .2667rem .4267rem 0rem .4267rem;
        font-size: .3733rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        b {
            font-size: .3733rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }
    }
}
.footer {
    width: 100%;
    height: 2.6667rem;
    background: linear-gradient(180deg, #75A3FF 0%, #4B85FF 100%);
    border-radius: .2133rem .2133rem 0 0;
    position: fixed;
    bottom: 0rem;
    text-align: center;
    z-index: 10;
    button {
        align-items: center;
        background: url('../../assets/images/unlockButton.png') no-repeat;
        background-size: 100%;
        width: 6.8533rem;
        height: 1.0133rem;
        border-radius: 2.4rem;
        border: 0rem;
        margin-top: .64rem;
        font-size: .5333rem;
        font-weight: 600;
        color: #FFFFFF;
    }
}
.specifications {
  width: 100%;
  height: 10.2933rem;
  background-color: #fff;
  background: linear-gradient(180deg, #FFFFFF 0%, #AEF4FB 100%);
  border-radius: .2133rem .2133rem 0 0;
  position: fixed;
  bottom: 0rem;
  z-index: 20;
  .close {
    width: .3467rem;
    height: .3467rem;
    background: url('../../assets/images/closeButton.png') no-repeat;
    background-size: 100%;
    position: absolute;
    top: .2133rem;
    right: .2133rem;

  }
  .productDetails {
    width: 9.2533rem;
    height: 2.9867rem;
    background: url('../../assets/images/productDetailsBack.png') no-repeat;
    background-size: 100%;
    border-radius: .2133rem .2133rem .2133rem .2133rem;
    opacity: 1;
    margin: 0 auto;
    margin-top: 1.52rem;
    padding: .16rem;
    display: flex;
    .icon {
      width: 2.6667rem;
      height: 2.6667rem;
      border-radius: .2133rem;
      img {
        width: 2.6667rem;
        height: 2.6667rem;
        border-radius: .2133rem;
      }
    }
    .priceIntroduction {
      height: 2.6667rem;
      width: 6.1067rem;
      margin-left: .16rem;
      padding: 10px 0 0 .16rem ;
      .title {
        font-size: 18px;
        font-weight: 600;
        color: #000000;
        line-height: .6933rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .priceCantent {
        height: .88rem;
        width: 5.3333rem;
        margin-top: .72rem;
        .preferentialPrice {
          line-height: .88rem;
          font-size: .64rem;
          font-weight: 600;
          color: #000000;
          float: left;
          position: relative;
          div {
            width: 1.6rem;
            height: .7467rem;
            position: absolute;
            top: -0.48rem;
            right: -1.28rem;
            background: url('../../assets/images/preferential.png') no-repeat;
            background-size: 100%;
            padding-left: .1067rem;
            span {
              width: 1.4933rem;
              height: .5333rem;
              font-size: .3467rem;
              font-weight: 400;
              color: #FFFFFF;
              float: left;
              line-height: .5867rem;
            }
          }
        }
        .marketPrice {
          height: .88rem;
          font-size: .3733rem;
          line-height: .9333rem;
          font-weight: 400;
          color: #5E5E5E;
          margin-left: .1867rem;
          float: left;
        }
      }
    }
  }
  .select {
    margin-top: .32rem;
    width: 100%;
    height: 2.8533rem;
    padding: 0 .7467rem;
    display: flex;
    justify-content: space-between;
    // background-color: #fff;
    .text {
      width: 2.4rem;
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: #000000;
      line-height: 28px;
    }
    .selectSpecifications {
      width: 5.5467rem;
      margin-bottom: .5067rem;
      .item {
        width: 5.5467rem;
        height: .8533rem;
        border-radius: .2133rem;
        background-color: #BFBFBF;
        margin-bottom: .32rem;
        text-align: center; 
        font-size: 14px;
        font-weight: 600;
        color: #000000;
        line-height: .88rem;
        padding: 0 .2133rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .active {
        background-color: #75A3FF;
      }
    }
  }
  .purchaseBox {
    width: 100%;
    height: 2.6133rem;
    border-radius: .2133rem .2133rem 0 0;
    background: linear-gradient(180deg, #75A3FF 0%, #4B85FF 100%);
    text-align: center;
    button {
        align-items: center;
        background: url('../../assets/images/unlockButton.png') no-repeat;
        background-size: 100%;
        width: 6.8533rem;
        height: 1.0133rem;
        border-radius: 2.4rem;
        border: 0rem;
        margin-top: .64rem;
        font-size: .5333rem;
        font-weight: 600;
        color: #FFFFFF;
    }
  }
}
.otherzhankai {
  transition: transform 0.5s ease;
  transform: translateY(100%);
}
.zhankai {
  transition: transform 0.5s ease;
  transform: translateY(0px);
}
.maskBack{
  position:absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  // background: rgba(0,28,28,0.3);
  // backdrop-filter: blur(2px);
}
</style>